import {IconButton} from '@mui/material';
import React, {useEffect, useState} from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = ({target}) => {
        if (target.scrollTop > 400) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        const main = document.querySelector('#content');
        if (!main) return;
        main.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const main = document.querySelector('#content');
        if (!main) return;
        main.addEventListener('scroll', handleScroll);
        return () => {
            main.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        isVisible && (
            <IconButton
                title="Revenir en haut de la page"
                aria-label="Revenir en haut de la page"
                sx={scrollToTopButtonStyle}
                onClick={scrollToTop}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-up"
                >
                    <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
            </IconButton>
        )
    );
};
const scrollToTopButtonStyle = (theme) => ({
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    p: 1.5,
    backgroundColor: 'black',
    borderRadius: 0,
    boxSizing: 'border-box',
    zIndex: 2000,
    ['@media (max-width: 480px)']: {
        display: 'none',
    },
    '& svg': {
        stroke: 'white',
        width: '32px',
        height: '32px',
    },
});

export default ScrollToTopButton;
